








import { Component, Vue } from "vue-property-decorator";
import Navigation from "@/components/Navigation.vue";

@Component({
  components: {
    Navigation
  }
})
export default class App extends Vue {
  transitionDelay: number = 300 /* ms */;

  created() {
    // initialize scroll to element
    Vue.prototype.common.initScrollTo();

    // add delay before transitioning to a different router page
    this.$router.beforeEach((to, from, next) => {
      document.getElementById("stage-curtain")!.classList.remove("open");
      setTimeout(() => {
        next();
      }, this.transitionDelay);
    });

    // add delay 
    this.$router.afterEach((to, from) => {
      setTimeout(() => {
        document.getElementById("stage-curtain")!.classList.add("open");
      }, this.transitionDelay);
    });
  }

  mounted() {
    // initial transition on first visit
    setTimeout(() => {
      document.getElementById("stage-curtain")!.classList.add("open");
    }, this.transitionDelay);
  }
}
